import { Box } from '@superdispatch/ui-lab';
import { useRef } from 'react';
import { PermissionView } from '../permission/core/PermissionView';
import { LoadSuggestionsDrawerContent } from './LoadSuggestionsDrawer';
import { viewportHeight } from 'shared/layout/NavigationHeaderBannerHeight';

export function LoadSuggestionsPageMobile() {
  const visibleLoadSuggestionIds = useRef(new Set<number>([]));

  return (
    <Box
      paddingBottom="xxlarge"
      backgroundColor="White"
      height={viewportHeight('48px')}
    >
      <PermissionView name="marketplace" permission="can_view">
        <LoadSuggestionsDrawerContent
          fullWidth={true}
          onView={(load) => {
            if (!load.is_seen) {
              visibleLoadSuggestionIds.current.add(load.suggestion_id);
            }
          }}
        />
      </PermissionView>
    </Box>
  );
}
